import React, { PureComponent, PropTypes } from 'react';
import reactTimeout from 'react-timeout';

import './SlideInFromTheSideModal.scss';

export const SLIDE_DIRECTION_RIGHT = 'right';
export const SLIDE_DIRECTION_LEFT = 'left';

export class SlideInFromTheSideModal extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    modalConfig: PropTypes.shape({
      slideDirection: PropTypes.oneOf([
        SLIDE_DIRECTION_RIGHT,
        SLIDE_DIRECTION_LEFT,
      ]),
    }),
    onModalClose: PropTypes.func.isRequired,
    setTimeout: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isMobileBreakpoint: false,
    modalConfig: {},
  };

  modalClose = (event) => {
    event.preventDefault();
    this.props.onModalClose(event);
  };

  render() {
    const {
      children,
      modalConfig,
    } = this.props;

    const { hideCloseButton, slideInFromTheSide } = modalConfig;
    const { isClosing } = modalConfig;

    const slideDirectionModifier = slideInFromTheSide === SLIDE_DIRECTION_LEFT ? '--slide-left' : '--slide-right';
    const style = {
      width: modalConfig.width || 600,
    };

    return (
      <section style={style} className={`slide-in-from-the-side-modal slide-in-from-the-side-modal${slideDirectionModifier} ${isClosing ? 'slide-in-from-the-side-modal--closing' : ''}`}>
        <div onClick={hideCloseButton ? '' : this.modalClose} className="slide-in-from-the-side-modal__screen" />
        <div className="slide-in-from-the-side-modal__content">
          <div className="slide-in-from-the-side-modal__header" onClick={this.modalClose}>
            {modalConfig.title}
          </div>
          <div className="slide-in-from-the-side-modal__content__inner">
            {children}
          </div>
        </div>
      </section>
    );
  }
}

export default reactTimeout(SlideInFromTheSideModal);



/** WEBPACK FOOTER **
 ** ./src/components/Modal/SlideInFromTheSideModal.jsx
 **/